// CustomMarker.ts
export default function createCustomMarkerClass() {
	if (!window.google) {
		throw new Error('Google Maps not loaded')
	}

	return class CustomMarker extends google.maps.OverlayView {
		constructor(
			public div: HTMLDivElement,
			map: google.maps.Map,
			public center: google.maps.LatLngLiteral,
		) {
			super()
			this.setMap(map)
		}

		onAdd(): void {
			const panes = this.getPanes()
			if (panes?.overlayMouseTarget) {
				panes.overlayMouseTarget.appendChild(this.div)
			}
		}

		onRemove(): void {
			if (this.div.parentNode) {
				this.div.parentNode.removeChild(this.div)
			}
		}

		setPosition(center: google.maps.LatLngLiteral) {
			this.center = center
			this.draw()
		}

		draw() {
			const overlayProjection = this.getProjection()
			const point = overlayProjection.fromLatLngToDivPixel(this.center)

			if (this.div) {
				this.div.style.position = 'absolute'
				this.div.style.left = `${point.x - this.div.offsetWidth / 2}px`
				this.div.style.top = `${point.y - this.div.offsetHeight}px`
			}
		}

		public remove() {
			this.setMap(null)
		}
	}
}
